import React from 'react'
import "./news.css"
import blogImg1 from "./images/blog-7.webp"
import blogImg2 from "./images/blog 3.webp"
import blogImg3 from "./images/blog 1.webp"

function News() {
  return (
    <div className='news-container'>
      <div className="news-content">
        <div className="blog-main-head">
          <h1>LATEST NEWS & UPDATES</h1>
        </div>
        <div className="news-blog">
          <div className="row-blog">
            <div className="blog1">
              <img src={blogImg1} alt="" className="blog-img" />
              <p className='blog-date'>September 15, 2023</p>
              <p className='blog-heading'>Make Listening To Music A New Dark Night Delightful Experience</p>
            </div>
            <div className="blog2">
              <img src={blogImg2} alt="" className="blog-img" /> 
              <p className='blog-date'>September 15, 2023</p>
              <p className='blog-heading'>Speakers To Your Life That Make You Forget Everything Around</p>
            </div>
          </div>
          <div className=" col-blog blog3">
            <img src={blogImg3} alt="" className="blog-img blog-img3" />
            <p className='blog-date'>September 15, 2023</p>
            <p className='blog-heading'>Smart Watches So Good, You Will Not Want To Take It Off Your Style</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default News
